export const DEVICE_TYPES = {
  "PHONE": "Mobile Phone / Smart Phone",
  "IPHONE": "iPhone",
  "TABLET": "iPads / Tablets"
}